/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */

import * as React from "react";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import { createStyles } from "@material-ui/core";

// Apricot
import { sectionWhyStyle } from "assets/jss/views/landingPage/landingPageSectionsStyle";

// CT UX
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";

import { PhoenixWhyCard } from "./SectionWhyCard";
import { whyContent } from "./landingPageContent";
import { sWhy, sWho, sWhyMsg } from "assets/jss/views/ResStrings";

const styles = createStyles(sectionWhyStyle as any);
interface Props extends WithStyles<typeof styles> {
  // other properties, if any
}
const PhoenixWhyBase: React.FC<Props> = ({ classes }: Props) => {
  const renderTargets = () =>
    whyContent.map((content, idx) => (
      <GridItem xs={12} sm={8} md={4} key={idx} className={classes.whyCard}>
        <PhoenixWhyCard content={content} />
      </GridItem>
    ));

  const HtmlToReactParser = require("html-to-react").Parser;
  const parser = new HtmlToReactParser();
  return (
    <div className={classes.section}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={8} md={10}>
          <h2 className={classes.title}>{sWhy}</h2>
          <h3 className={classes.description}>{parser.parse(sWhyMsg)}</h3>
        </GridItem>
      </GridContainer>

      <h2 className={classes.title} style={{ marginTop: "2rem" }}>
        {sWho}
      </h2>
      <GridContainer>{renderTargets()}</GridContainer>
    </div>
  );
};

export const PhoenixWhy = withStyles(styles)(PhoenixWhyBase);
